import type { RootState } from '@/state';

export const selectAmenities = ({ referenceData }: RootState) =>
  referenceData.amenities;

export const selectAreas = ({ referenceData }: RootState) =>
  referenceData.areas;

export const selectPropertyTypes = ({ referenceData }: RootState) =>
  referenceData.propertyTypes;

export const selectSeasons = ({ referenceData }: RootState) =>
  referenceData.seasons;

export const selectReferenceDataLoading = ({ referenceData }: RootState) =>
  referenceData.loading;

export const selectReferenceDataLoaded = ({ referenceData }: RootState) =>
  referenceData.loaded;

export const selectReferenceDataLocale = ({ referenceData }: RootState) =>
  referenceData.loadedLocale;
